require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2007-06-12-ev-certificates.json") })
        }
      }, "path---articles-2007-06-12-ev-certificates");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2007-06-12-ev-certificates!./.cache/json/articles-2007-06-12-ev-certificates.json
// module id = 519
// module chunks = 231608221292675